import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { SupportCategorySelector } from '@bingads-webui-react/support-category-selector';
import { i18nLanguageToDisaplyLanguage } from '@bingads-webui-react/support-market-mapping';

const Warning = props => (
  <div style={{ 'margin-bottom': '10px', color: '#D83B01' }}>
    <span className="status-icon iconba iconba-Warning" title={props.i18n.getString('Warning')} aria-label={props.i18n.getString('Warning')} role="img" />
    {props.message}
  </div>
);

Warning.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
    getCldr: PropTypes.func,
  }).isRequired,
  message: PropTypes.string.isRequired,
};
export class MsSupportChatSurvey extends React.PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmitControlRole: PropTypes.string,
    i18n: PropTypes.shape({
      getString: PropTypes.func,
      getCldr: PropTypes.func,
    }).isRequired,
    featureName: PropTypes.string,
    permissions: PropTypes.shape({}),
    activity: PropTypes.shape({
      signal: PropTypes.func,
    }),
    logger: PropTypes.shape({
      trace: PropTypes.func,
    }),
    market: PropTypes.shape({}),
  };

  static defaultProps = {
    featureName: '',
    permissions: {},
    activity: { signal: _.noop },
    logger: { trace: _.noop },
    market: undefined,
    onSubmitControlRole: 'button',
  };

  state = {
    description: '',
    issue: '-1',
    isLoading: true,
  };

  onSelectChange = (issue, customSupportLink) => {
    this.setState({
      issue,
      isLoading: issue === '-1',
      customSupportLink,
    });
  };

  descriptionInputId = `description-input-${_.uniqueId()}`;

  handleSubmit = () => {
    this.props.onSubmit({
      description: this.state.description,
      issue: this.state.issue,
      customSupportLink: this.state.customSupportLink,
    });

    const { market, i18n } = this.props;
    let { language, region } = i18n.getCldr().attributes;
    if (market) {
      ({ language, region } = market);
    }
    this.props.activity.signal(`issue: ${this.state.issue}, description: ${this.state.description}, language: ${language}, region: ${region}`);
    this.props.logger.trace('support-chat-modal: handleSubmit', `issue: ${this.state.issue}, description: ${this.state.description}, language: ${language}, region: ${region}`);
  };

  handleInputChange = (e) => {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
    });
  };

  render() {
    const { market, i18n, onSubmitControlRole } = this.props;
    let { language, region } = i18n.getCldr().attributes;
    if (market) {
      ({ language, region } = market);
    }
    this.props.activity.signal(`MsSupportChatSurvey render, language: ${language}, region: ${region}`);
    this.props.logger.trace(`support-chat-modal: render', 'MsSupportChatSurvey render, language: ${language}, region: ${region}`);

    return (
      <div className="ms-support-chat-form">

        <div className="ms-support-chat-form-header">
          <button className="close" aria-label={market ? 'Close' : i18n.getString('MsSupportChatModal_Close')} onClick={this.props.onCancel}>
            <span className="closeimage iconba iconba-Cancel" />
          </button>
          <div id="msSupportChatFormTitle" role="heading" aria-level="3">{market ? 'Start a live chat' : i18n.getString('MsSupportChatModal_Title')}</div>
        </div>

        <div className="ms-support-chat-form-body">
          {
            region === 'BR' && <Warning i18n={i18n} message={i18n.getString('MsSupportChatModal_BR_Alert')} />
          }
          {
            i18nLanguageToDisaplyLanguage[language] === 'EN' && <Warning i18n={i18n} message={i18n.getString('MsSupportChatModal_EN_Alert')} />
          }
          <SupportCategorySelector
            i18n={this.props.i18n}
            onMount={this.onSelectChange}
            onSelectChange={this.onSelectChange}
            featureName={this.props.featureName}
            permissions={this.props.permissions}
            market={market}
            for="chat"
          />
          <div className="form-group">
            <label htmlFor={this.descriptionInputId}>
              {market ? 'Description' : i18n.getString('MsSupportChatModal_Description')}
              <textarea
                data-clarity-unmask="true"
                maxLength={500}
                className="form-control"
                name="description"
                id={this.descriptionInputId}
                onChange={this.handleInputChange}
                value={this.state.description}
                rows="5"
                placeholder={market ? 'Add more information so we can help you quickly.' : i18n.getString('MsSupportChatModal_Description_Placeholder')}
              />
            </label>
          </div>
        </div>

        <div className="ms-support-chat-form-footer">
          <button className="btn btn-primary" onClick={this.handleSubmit} disabled={this.state.isLoading} role={onSubmitControlRole}>
            {market ? 'Continue' : i18n.getString('MsSupportChatModal_Continue')}
          </button>
          <button className="btn btn-default" onClick={this.props.onCancel}>{market ? 'Cancel' : i18n.getString('MsSupportChatModal_Cancel')}</button>
        </div>
      </div>
    );
  }
}
